import { Link } from "react-router-dom";
import { AppBar } from '@mui/material';
import { Toolbar } from '@mui/material';

function HeaderLogoOnly({performSearch, setSearchText, searchText}) {


  return (
<AppBar position='static'>
<Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
<Link to='/'>
  <img src='/xflix-logo.png' alt='logo' style={{ height: '35px', marginRight: '10px' }}/>
  </Link>
</Toolbar>
</AppBar>
  )
}

export default HeaderLogoOnly